
export const Logout = () => {
  localStorage.clear();
};
